(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["well-card-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    if (!event.target.matches('.well-card-form input[name="well-variant"]')) return;
    const form = event.target.closest('form');
    form.querySelector('.product-variant-id').value = event.target.value;
    const price = event.target.closest('.card-information')?.querySelector('.price-item--regular');
    if (price) price.textContent = event.target.dataset.price;
  });
  } catch(e) { console.error(e); }
})();

})();
